export const generateDocumentsWithMode = async ({
  updateSubscription,
  generateSubscriptionDocuments,
  subscriptionId,
  mode,
  options = {},
}) => {
  const { errors } = await updateSubscription({
    variables: {
      where: { id: subscriptionId },
      data: { additionalInfo: { documentsGenerationMode: mode } },
    },
  });
  if (errors) return options.onError && options.onError(errors);
  return generateSubscriptionDocuments(options);
};
